var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewrites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 85,
    viewBox: "0 0 216 85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.546 8h68.4c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7H155.21c5 0 9.053 3.134 9.053 7s-4.053 7-9.053 7h28.455c5 0 9.054 3.134 9.054 7s-4.054 7-9.054 7h-13.16c-6.304 0-11.415 3.134-11.415 7 0 2.577 2.587 4.91 7.76 7 5 0 9.054 3.134 9.054 7s-4.053 7-9.054 7H116V59h22.905c2.261 0 4.095-1.89 4.095-4.222V14.425c0-1.102-.418-2.16-1.164-2.949L138.546 8ZM100 8v19H77a4 4 0 0 0-4 4v47H59.497c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7H9.054C4.054 64 0 60.866 0 57s4.054-7 9.054-7H60.79c5 0 9.054-3.134 9.054-7s-4.053-7-9.054-7H28.455c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7h51.737c-5 0-9.054-3.134-9.054-7s4.053-7 9.054-7H100Zm106.946 42c-5 0-9.054-3.134-9.054-7s4.054-7 9.054-7S216 39.134 216 43s-4.054 7-9.054 7Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 22v-6.765a7 7 0 0 1 7-7h8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "m89.5 4 4 3.794-4 3.618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 65v6.765a7 7 0 0 1-7 7h-8",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "m126.5 83-4-3.794 4-3.618"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77 28.13a2.75 2.75 0 0 0-2.75 2.75v49A2.75 2.75 0 0 0 77 82.63h35a2.75 2.75 0 0 0 2.75-2.75v-40.7c0-.704-.27-1.38-.753-1.89l-7.853-8.3a2.75 2.75 0 0 0-1.998-.86H77Z",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 28.88v7.945c0 1.135.733 2.056 1.637 2.056H114",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NotoSans-SemiBold, Noto Sans",
    fontSize: 13,
    fontWeight: 500,
    fill: "#6A6666",
    transform: "translate(73 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 44.881
  }, "A")), /*#__PURE__*/React.createElement("path", {
    d: "M100 28.016V6.103c0-2.332 1.834-4.222 4.095-4.222h27.047c1.104 0 2.16.459 2.931 1.273l7.763 8.203A4.291 4.291 0 0 1 143 14.305v40.353c0 2.332-1.834 4.223-4.095 4.223h-24.006",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 3.88v7.945c0 1.135.733 2.056 1.637 2.056H141",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NotoSans-SemiBold, Noto Sans",
    fontSize: 13,
    fontWeight: 500,
    fill: "#6A6666",
    transform: "translate(73 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    y: 20.881
  }, "B")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewrites);
export default __webpack_public_path__ + "static/media/rewrites.c25968010ad09599c007971d1a944ff6.svg";
export { ForwardRef as ReactComponent };